import { useState } from 'react';

const FORMSPREE_ID = process.env.REACT_APP_FORMSPREE_ID;

export default function useWaitlistForm() {
  const [fields, setFields] = useState({ name: '', email: '', useCase: '' });
  const [status, setStatus] = useState('idle'); // idle | loading | success | error

  const setField = (key) => (e) => {
    setStatus('idle');
    setFields((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, useCase } = fields;
    if (!name.trim() || !email || !/\S+@\S+\.\S+/.test(email) || !useCase.trim()) {
      setStatus('error');
      return;
    }
    setStatus('loading');
    try {
      const res = await fetch(`https://formspree.io/f/${FORMSPREE_ID}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          name,
          email,
          use_case: useCase,
          _subject: `Pramaan Early Access — ${name}`,
        }),
      });
      setStatus(res.ok ? 'success' : 'error');
    } catch {
      setStatus('error');
    }
  };

  return { fields, setField, status, handleSubmit };
}
